import { useState, useEffect } from "react";
import { Switch } from "@/components/ui/switch";
import { Pause, Play } from "lucide-react";

interface AnimationToggleProps {
  onToggle: (isPlaying: boolean) => void;
}

const AnimationToggle = ({ onToggle }: AnimationToggleProps) => {
  const [isPlaying, setIsPlaying] = useState(true);

  const handleToggle = () => {
    const newState = !isPlaying;
    setIsPlaying(newState);
    onToggle(newState);
  };

  return (
    <div 
      className="fixed top-30 right-6 z-50 flex items-center gap-2 bg-background/90 backdrop-blur-sm border border-border rounded-full px-3 py-2 shadow-lg"
      role="region"
      aria-label="Animation controls"
    >
      <div className="text-xs text-muted-foreground hidden sm:block">
        Animation
      </div>
      <div className="flex items-center gap-2">
        {isPlaying ? (
          <Play className="w-3 h-3 text-primary" aria-hidden="true" />
        ) : (
          <Pause className="w-3 h-3 text-muted-foreground" aria-hidden="true" />
        )}
        <Switch
          checked={isPlaying}
          onCheckedChange={handleToggle}
          className="data-[state=checked]:bg-primary"
          aria-label={isPlaying ? "Pause animations" : "Play animations"}
        />
      </div>
    </div>
  );
};

export default AnimationToggle;